import {AppEnvironment} from './app-environment';

export const environment: AppEnvironment = {
  production: true,
  version: '1.0.0',
  apiUrl: '',
  authority: '',
  clientId: '',
  redirectUrl: '',
  maxFileSizeBytes: 5 * 1024 * 1024,
  apmEnabled: false,
  apmUrl: '',
  name: ''
};
